// extracted by mini-css-extract-plugin
export default {"prev":"SwiperPrev_prev__kfOlB","position":"SwiperPrev_position__Q-jla"};